/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { changeModalVisibility } from '../../../../setup/slices/ModalSlice'
import { KTSVG } from '../../../../_metronic/helpers'
import { GetCustomersByExcel } from '../../AnaVezne/apis/ApiCall'
import CustomerSearch from './CustomerSearch'
import { CustomerModel, CustomerModelTahsilat } from '../../../types'
import './content.css'
import { Button, Modal } from 'react-bootstrap-v5'

interface Props {
  setCustomer: React.Dispatch<React.SetStateAction<any>>
  isLoading: boolean
  customerList: any
  isAdmin: boolean
  setSearchText: React.Dispatch<React.SetStateAction<string>>
  message: string
  workInCustomerId: string
}

const CustomersTable: React.FC<Props> = ({
  setCustomer,
  isLoading,
  customerList,
  isAdmin,
  setSearchText,
  message,
  workInCustomerId,
}) => {
  const dispatch = useDispatch()

  const [sortedColumn, setSortedColumn] = React.useState<string>('')
  const [sortedData, setSortedData] = React.useState<any[]>([])
  const [sortOrder, setSortOrder] = useState('asc')
  const [noticeButton, setNoticeButton] = React.useState<boolean>(false)
  const [selectedCustomerNote, setSelectedCustomerNote] = useState<string>('')
  const [selectedCustName,setSelectedCustName] = useState<string>('')
  const [selectedCustomerCallCode, setSelectedCustomerCallCode] = useState<string>('')

  const handleClick = (customer: any) => {
    dispatch(changeModalVisibility(true))
    setCustomer(customer)
  }

  console.log("customerListcustomerList",customerList)

  const handleSort = (column: keyof CustomerModelTahsilat) => {
    const newSortedData = customerList
    let newSortOrder = 'asc'

    if (sortedColumn === column) {
      newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
    }

    newSortedData.sort((a: CustomerModelTahsilat, b: CustomerModelTahsilat) => {
      const valueA = a[column]
      const valueB = b[column]

      if (valueA === null && valueB === null) {
        return 0
      }

      if (valueA === null) {
        return -1
      }

      if (valueB === null) {
        return 1
      }

      if (typeof valueA === 'number' && typeof valueB === 'number') {
        return newSortOrder === 'asc' ? valueA - valueB : valueB - valueA
      } else if (typeof valueA === 'string' && typeof valueB === 'string') {
        return newSortOrder === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
      } else {
        return 0
      }
    })

    setSortedData(newSortedData)
    setSortedColumn(column)
    setSortOrder(newSortOrder)
  }

  console.log(handleSort)

  const downloadExcel = (customers: any[]) => {
    if (customerList.length > 0) {
      let excelCustomers = customers.map((customer: any) => {
        delete customer.AramaTarihi
        delete customer.OdemeTarihi
        customer.Note = customer.Not
        delete customer.Not
        customer.CustomerId = customer.CustomerId.toString()
        customer.GecikmeGunOrt !== null
          ? (customer.GecikmeGunOrt = customer.GecikmeGunOrt.toString())
          : (customer.GecikmeGunOrt = '')
        customer.TotalBalance !== null
          ? (customer.TotalBalance = customer.TotalBalance.toString())
          : (customer.TotalBalance = '')
        customer.TotalOverDue !== null
          ? (customer.TotalOverDue = customer.TotalOverDue.toString())
          : (customer.TotalOverDue = '')
        customer.CustName =
          customer.CustName !== null ? customer.CustName : 'Kayıtlı İsim Bilgisi Yok!'
        return customer
      })
      GetCustomersByExcel(excelCustomers)
    }
  }

  const hideNoticeButton = () => {
    setNoticeButton(false);
  }

  const handleNoticeButton = (customer: any) => {
    setSelectedCustomerNote(customer.Not || '-')
    setSelectedCustName(customer.CustName || '-')
    setSelectedCustomerCallCode(customer.Customerreference || '-')
    setNoticeButton(true);
  };


  return (
    <div className={'card-xxl-stretch mb-5 mb-xl-8'}>
      {/* begin::Header */}
      <div className='card-header border-0 row px-0'>
        <div className='row align-items-end justify-content-end w-100 px-0'>
          <div className='col-md-3 px-3'>
            <CustomerSearch setSearchText={setSearchText} />
          </div>
          {!isAdmin && (
          <div className='px-0 ms-5' style={{ width: "16rem" }}>
              <div className='d-flex'>
                <div className=''>
                  <Button className='btn btn-success' onClick={() => downloadExcel(customerList)}>
                    {/* TODO excel indirme müşteriye göre değişecek biçimde olacak */}
                    <KTSVG path='/media/icons/duotune/Layout/Layout-top-panel-5.svg' />
                    <span>Müşteri Listesini İndir</span>
                  </Button>
                </div>
              </div>
          </div>
          )}
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-4 px-0'>
        {/* begin::Table container */}
        <div className='table-responsive h-500px card-scroll'>
          {/* begin::Table */}
          <table className='table align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder bg-light' style={{ textAlign: 'center', color: "#444", borderBottom: "1px solid rgb(0, 158, 247, 0.8" }}>
                <th
                  className='ps-4 w-100px rounded-start tahsilatBaslik text-left'
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleSort('Customerreference')}
                >
                  Kod
                </th>
                <th
                  className='px-4 w-100px rounded-end tahsilatBaslik text-left'
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleSort('AtCustNo')}
                >
                  SAP No
                </th>
                <th
                  className='w-250px tahsilatBaslik text-left'
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleSort('CustName')}
                >
                  Müşteri Adı
                  {/* {sortOrder === 'desc' ? (
                    <i className='bi bi-sort-down sortHandle'></i>
                  ) : (
                    <i className='bi bi-sort-up sortHandle'></i>
                  )} */}
                </th>
                <th
                  className='w-100px tahsilatBaslik text-left'
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleSort('VergiNo')}
                >
                  VK No
                </th>
                <th
                  className='w-70px tahsilatBaslik'
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleSort('TotalBalance')}
                >
                  Toplam Borç
                </th>
                <th
                  className='w-70px tahsilatBaslik bg-secondary'
                  style={{ cursor: 'pointer', borderBottom: "1px solid rgb(0, 158, 247, 0.8" }}
                  onClick={() => handleSort('TotalOverDue')}
                >
                  Geciken Borç
                </th>
                <th
                  className='w-70px tahsilatBaslik'
                  style={{ cursor: 'pointer', borderBottom: "1px solid rgb(0, 158, 247, 0.8", background: "#eaecf3" }}
                  onClick={() => handleSort('GecikmeGunOrt')}
                >
                  Ortalama Vade
                </th>
                <th
                  className='w-300px tahsilatBaslik'
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleSort('AramaSonucu')}
                >
                  Arama <br></br>Sonucu
                </th>
                <th
                  className='w-100px tahsilatBaslik'
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleSort('PlanTarihi')}
                >
                  Plan Tarihi
                </th>
                <th
                  className='w-50px tahsilatBaslik'
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleSort('BeklenenOdeme')}
                >
                  Beklenen Ödeme
                </th>
                <th
                  className='w-70px tahsilatBaslik'
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleSort('OdemeKanali')}
                >
                  Ödeme Kanalı
                </th>
                <th
                  className='px-4 w-70px rounded-end tahsilatBaslik'
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleSort('Not')}
                >
                  Not
                </th>
              </tr>
            </thead>
            {/* begin::Table body */}
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={11}>
                    <h1 className='text-center mt-4'>Yükleniyor...</h1>
                  </td>
                </tr>
              ) : !isLoading ? (
                customerList.length > 0 ? (
                  customerList.map((customer: any, index: number) => {
                    let bgColor = 'white'

                    if (customer.PlanTarihi !== null) {
                      if (
                        customer.PlanTarihi.split('T')[0] ===
                        moment(new Date()).format('YYYY-MM-DD')
                      ) {
                        bgColor = 'bg-secondary'
                      }
                    }
                    console.log(customer)
                    return (
                      <tr key={index} className={bgColor}>
                        <td className='w-100px'>
                          <div
                            className='d-flex align-items-center justify-content-center'
                            onClick={() => handleClick(customer)}
                            style={{ cursor: 'pointer' }}
                          >
                            <span
                              className='text-primary fw-bolder d-block mb-1 fs-6'
                              style={{ textDecoration: 'underline' }}
                            >
                              {customer.Customerreference}
                            </span>
                          </div>
                        </td>
                        <td className='w-100px'>
                          <div className='d-flex align-items-center justify-content-center'>
                            <span className='text-gray-700 fw-bold d-block mb-1 fs-6'>
                              {customer.AtCustNo !== null ? customer.AtCustNo : '-'}
                            </span>
                          </div>
                        </td>
                        <td className='w-250px'>
                          <div className='d-flex align-items-center justify-content-start'>
                            <span className='text-dark fw-bold d-block mb-2 fs-6'>
                              {customer.CustName}
                            </span>
                          </div>
                        </td>
                        <td className='w-100px'>
                          <div className='d-flex align-items-center justify-content-center'>
                            <span className='text-gray-700 fw-bold d-block mb-1 fs-6'>
                              {customer.VergiNo}
                            </span>
                          </div>
                        </td>
                        <td className='w-70px'>
                          <div className='d-flex align-items-center justify-content-end'>
                            <span className='text-dark fw-bolder d-block mb-1 fs-5 text-center'>
                              {customer.TotalBalance?.toLocaleString('tr-TR')}
                            </span>
                          </div>
                        </td>
                        <td className='w-70px bg-secondary'>
                          <div className='d-flex align-items-center justify-content-end'>
                            <span className='text-danger fw-bolder d-block mb-1 fs-5 text-end'>
                              {customer.TotalOverDue?.toLocaleString('tr-TR')}
                            </span>
                          </div>
                        </td>
                        <td className='w-70px' style={{ background: "#eaecf3" }}>
                          <div className='d-flex align-items-center justify-content-center'>
                            <span className='text-gray-700 fw-bold d-block mb-1 fs-5'>
                              {customer.GecikmeGunOrt === null ? '-' : customer.GecikmeGunOrt}
                            </span>
                          </div>
                        </td>
                        <td className='w-150px'>
                          <div className='d-flex align-items-center justify-content-center text-right'>
                            <span className='text-gray-700 fw-bolder d-block mb-1 fs-6'>
                              {customer.AramaSonucu === "Hemen Ödeme" ? (<i className="bi bi-circle-fill text-success fs-9 me-2"></i>) : customer.AramaSonucu === "İleri Tarihli Ödeme" ? (<i className="bi bi-circle-fill text-warning fs-9 me-2"></i>) : customer.AramaSonucu === "Tekrar Aranacak" ? (<i className="bi bi-circle-fill text-danger fs-9 me-2"></i>) : ""}
                              {customer.AramaSonucu !== null ? customer.AramaSonucu : '-'}
                            </span>
                          </div>
                        </td>
                        <td className='w-100px'>
                          <div className='d-flex align-items-center justify-content-center text-right'>
                            <span className='text-gray-700 fw-bolder d-block mb-1 fs-7'>
                              {customer.OdemeTarihi !== ''
                                ? customer.OdemeTarihi !== null && customer.OdemeTarihi
                                : customer.AramaTarihi !== ''
                                  ? customer.AramaTarihi !== null && customer.AramaTarihi
                                  : customer.PlanTarihi !== ''
                                    ? customer.PlanTarihi !== null && customer.PlanTarihi.split('T')[0]
                                    : '-'}
                            </span>
                          </div>
                        </td>
                        <td className='w-70px'>
                          <div className='d-flex align-items-center justify-content-center'>
                            <span className='text-danger fw-bolder d-block mb-1 fs-6'>
                              {customer.BeklenenOdeme !== null ? customer.BeklenenOdeme : '-'}
                            </span>
                          </div>
                        </td>
                        <td className='w-70px'>
                          <div className='d-flex align-items-center justify-content-center'>
                            <span className='text-gray-500 fw-bolder d-block mb-1 fs-6'>
                              {customer.OdemeKanali !== null ? customer.OdemeKanali : '-'}
                            </span>
                          </div>
                        </td>
                        <td className='w-100px'>
                          <div className='d-flex align-items-center justify-content-center'>
                            <span className='text-gray-700 fw-bold d-block mb-1 fs-6'>
                              <button className='notButton border border-0 bg-primary py-2' onClick={() => handleNoticeButton(customer)}>
                              <i className='bi bi-blockquote-left fs-1 text-white'></i>
                              </button>
                              <Modal
                                show={noticeButton}
                                onHide={hideNoticeButton}
                                size="lg"
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                              >
                                <Modal.Header>
                                  <Modal.Title id="contained-modal-title-vcenter">
                                  {selectedCustName} Firmasının
                                  </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <h4> {selectedCustomerCallCode} Kodlu Arama Notu</h4>
                                  <p>{selectedCustomerNote !== '' ? selectedCustomerNote : 'İlgili aramaya ait not bulunamadı.'}</p>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button variant='secondary' onClick={hideNoticeButton}>
                                    Kapat
                                  </Button>
                                </Modal.Footer>
                              </Modal>
                            </span>
                          </div>
                        </td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td colSpan={11}>
                      <h1 className='text-center mt-4'>{message}</h1>
                    </td>
                  </tr>
                )
              ) : (
                <tr>
                  <td colSpan={11} className='text-center mt-4'>
                    {' '}
                    {message}
                  </td>
                </tr>
              )}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
  )
}

export default CustomersTable
